import React, { useState, useEffect } from 'react';
import {config} from "../../shared/config.js";
import * as util from '../../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError.jsx';
import Laoding from '../../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm.jsx';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import UserTypeCombo from '../../combos/UserTypeCombo.jsx';

var editedModules = [];
var editedParameters = {};
export default function UserList(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [users, setUsers] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [confirmResetPasswordVisible, setConfirmResetPasswordVisible] = useState(false);
    const [mobile, setMobile] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [nationalId, setNationalId] = useState("");
    const [email, setEmail] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [city, setCity] = useState(null);
    const [role, setRole] = useState(null);
    const [userId, setUserId] = useState("");
    const [userIndex, setUserIndex] = useState(-1);
    const [tafsilId, setTafsilId] = useState(0);
    const [date, setDate] = useState(0);
    const [newDate, setNewDate] = useState(0);
    const [searchPanelVisible, setSearchPanelVisible] = useState(false);
    const [searchOptions, setSearchOptions] = useState({includeAdmins:true, includeAssistants:true, includeAgents:true, includeClients:true, searchText:""});

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = function(){
        setLoading(true);
        var params = {
            login:util.getLoginDto(), 
            searchText:searchOptions.searchText,
            includeAdmins:searchOptions.includeAdmins,
            includeAssistants:searchOptions.includeAssistants,
            includeAgents:searchOptions.includeAgents,
            includeClients:searchOptions.includeClients,
        };
        var url = config.Server+`/user/list`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("setUsers is> ", response);
                for(var i=0;i<response.length;i++){
                    
                }
                setUsers(response);
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });

    }
    const onAddNewItemClick = function(){
        setUserId("");
        setTafsilId(0);
        setUserIndex(-1);
        editedModules = [];
        setIsActive(true);
        setFirstname("");
        setLastname("");
        setNationalId("");
        setEmail("");
        setCity(null);        
        setRole(null);
        setEditFormVisible(true);
    }
    const onRowEditClick = function(c, cInd){
        console.log("c is>", c)
        var user = c;
        setUserId(user.id);
        setTafsilId(user.tafsilId);
        setUserIndex(cInd);
        setDate(user.birthDate);
        setNewDate(user.birthDate);
        setFirstname(user.firstname);
        setLastname(user.lastname);
        setNationalId(user.nationalId);
        setMobile(user.mobile);
        setEmail(user.email);
        setIsActive(user.isActive);
        setCity(user.city);
        setRole(user.role)
        setEditFormVisible(true);
    }
    const setRowActions = function (row, cInd) {
        return (
        <Row className="justify-content-md-center" style={{}}>
            <Button icon="pi pi-pencil" rounded severity="success" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowEditClick(row, cInd)} title="ویرایش" />
            <Button icon="pi pi-wave-pulse" rounded severity="primary" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowResetPasswordClick(row, cInd)} title="ریست کردن کلمه عبور" />
            <Button icon="pi pi-trash" rounded severity="danger" style={{ width: "45px", margin: "0px 3px", float: "right", borderRadius:"5px" }} onClick={() => onRowDeleteClick(row, cInd)} title="حذف" />
        </Row>
        );
    }
    const setRowBirthDate = function (row, cInd) {
        return(
            <>
                <label>&nbsp;{util.toPersianDigits(util.SeperateDate(row.birthDate))}</label>
            </>
        )
    }
    //=====================================================================================================================================
    //============                  user edit form                  =======================================================================
    //=====================================================================================================================================
    const checkDataEntry = function(){
        var check = util.IsMobileValid(mobile);
        if(!check.valid){
            setErrorMessage(check.msg);
            setErorVisible(true);
            return false;
        }
        if(firstname.trim().length < 2){
            setErrorMessage("نام را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(lastname.trim().length < 2){
            setErrorMessage("نام خانوادگی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(role == null){
            setErrorMessage("نوع حساب کاربری را مشحص کنید");
            setErorVisible(true);
            return false;
        }
        if(role.id<=0){
            setErrorMessage("نوع حساب کاربری را مشحص کنید");
            setErorVisible(true);
            return false;
        }
        if(city == null){
            setErrorMessage("استان و شهر را مشحص کنید");
            setErorVisible(true);
            return false;
        }
        if(city.cityId < 10){
            setErrorMessage("استان و شهر را مشحص کنید");
            setErorVisible(true);
            return false;
        }

        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        var url = config.Server + `/user/save`;
        var params = {
            login:util.getLoginDto(), 
            id:userId,
            mobile:mobile,
            firstname:firstname,
            lastname:lastname,
            nationalId:nationalId,
            isActive:isActive,
            email:email,
            birthDate:newDate,
            cityId:city.id,
            tafsilId:tafsilId,
            role:role.id,
        };
        setSaving(true);
        console.log("user is>", params);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var ncs = [...users];
                if(userIndex == -1){                    
                    ncs.push({...response});                    
                }
                else{
                    ncs[userIndex] = {...response};
                }
                setUsers(ncs);
                setSaving(false);
                setEditFormVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{setEditFormVisible(false)}} saving={saving} />
        )
    }
    //=====================================================================================================================================
    //============                  delete user                  =======================================================================
    //=====================================================================================================================================
    const onRowDeleteClick = function(user, cInd){
        setUserId(user.id);
        setTafsilId(user.tafsilId);
        setUserIndex(cInd);
        setConfirmDeleteVisible(true);
    }
    const deleteItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:userId};
        var url = config.Server+`/user/delete`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var ncs = [...users];
                ncs.splice(userIndex, 1);
                setUsers(ncs);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }
    //=====================================================================================================================================
    //============                  reset user pass                 =======================================================================
    //=====================================================================================================================================
    const onRowResetPasswordClick = function(user, cInd){
        setUserId(user.id);
        setTafsilId(user.tafsilId);
        setUserIndex(cInd);
        setConfirmResetPasswordVisible(true);
    }
    const resetPasswordItem = function(){
        setDeleting(true);
        var params = {login:util.getLoginDto(), id:userId};
        var url = config.Server+`/user/by-admin/password/reset`;
        axios
            .post(url, params )
            .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                
                setDeleting(false);
                setConfirmResetPasswordVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
            })
            .catch(error => {
                setDeleting(false);
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const onResetPasswordConfirm_Accept = function(){
      resetPasswordItem();
    }
    const onResetPasswordConfirm_Reject = function(){
        if(deleting) return;
        setConfirmResetPasswordVisible(false);
    }

    const onTafsilIdChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setTafsilId(v);
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "firstname") setFirstname(val);
        else if(name === "lastname") setLastname(val);
        else if(name === "email") setEmail(val);
        else if(name === "mobile") setMobile(val);
        else if(name === "nationalId") setNationalId(val);
    }
    const onSearchInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        var so = {...searchOptions};
        if((name === "searchText")) so[name] = val;
        setSearchOptions(so);
    }
    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        (loading)?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست کاربران..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            
            
            <div style={{textAlign:"center", padding:"5px", backgroundColor:"#ccc", marginTop:"10px", borderTopRightRadius:"5px", borderTopLeftRadius:"5px"}}>
                لیست کاربران
            </div>
            {
              searchPanelVisible?
              <Row style={{border:"1px dashed #b0b0b0", padding:"5px", margin:"10px 0px 0px 0px"}}>
                <Col md={3} style={{marginTop:"20px"}}>
                    <FloatLabel>
                        <InputText value={searchOptions.searchText} onChange={(e)=>{onSearchInputChange(e, "searchText")}} id="searchText" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                        <label htmlFor="searchText">کاربر</label>
                    </FloatLabel>                                                                      
                </Col>
                <Col md={3} style={{marginTop:"0px"}}>                
                </Col>
                <Col md={12} style={{marginTop:"30px"}}>
                    <Button label="&nbsp;&nbsp;  جستجو کن  &nbsp;&nbsp;" icon="pi pi-search" onClick={()=>loadItems()} severity="primary" iconPos="right" style={{borderRadius:"5px"}} />
                </Col>
              </Row>
              :<></>
            }

              <Row style={{}}>
                <Col xs={2} md={12}>
                    <table>
                        <tr>
                            <td style={{padding:"5px"}}><Button label="" icon="pi pi-search" onClick={()=>setSearchPanelVisible(!searchPanelVisible)} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                            <td style={{padding:"5px"}}><Button label="ثبت کاربر جدید" icon="pi pi-plus" onClick={()=>onAddNewItemClick()} severity="secondary" iconPos="right" style={{borderRadius:"5px"}} /></td>
                        </tr>
                    </table>
                </Col>
              </Row>

              <DataTable value={users} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{}} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id">
                {/* <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column> */}
                <Column header="#" headerStyle={{ width: '20px' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
                {config.ShowListId ? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column> : <></>}
                <Column field="tafsilId" header={"تفضیل"} sortable className="list-cell-text-align"></Column>
                <Column field="mobile" header={"موبایل"} sortable className="list-cell-text-align"></Column>
                <Column field="firstname" header={"نام"} sortable className="list-cell-text-align"></Column>
                <Column field="lastname" header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                <Column field="nationalId" header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                <Column field="birthDate" header={"تولد"} body={(row, options) => setRowBirthDate(row, options.rowIndex)} sortable className="list-cell-text-align"></Column>
                <Column body={(row, options) => setRowActions(row, options.rowIndex)} exportable={false} style={{ }}></Column>
              </DataTable>

            {
                editFormVisible?
                <Dialog visible={true} style={{ width: '50rem', height:"calc(100vh - 150px)" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                header="ثبت مشخصات کاربر" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => setEditFormVisible(false)}>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="title" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="firstname">موبایل</label>
                            </FloatLabel>                                                    
                        </Col>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={tafsilId} onChange={(e)=>{onTafsilIdChanged(e.target.value)}} id="tafsilId" keyfilter="int" maxLength={7} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="tafsilId">کد تفضیل</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={firstname} onChange={(e)=>{onInputChange(e, "firstname")}} id="firstname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                <label htmlFor="firstname">نام</label>
                            </FloatLabel>                                                    
                        </Col>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={lastname} onChange={(e)=>{onInputChange(e, "lastname")}} id="lastname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"rtl"}} />
                                <label htmlFor="lastname">نام خانوادگی</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <div key={"isActive"} className="flex align-items-center">
                                <Checkbox value={isActive} inputId={"isActive"} onChange={(e)=>setIsActive(e.checked)} checked={isActive} />
                                <label htmlFor={"isActive"} className="ml-2">&nbsp;حساب کاربری فعال باشد</label>
                            </div>
                        </Col>
                        <Col md={6} style={{marginTop:"2px"}}>
                            <UserTypeCombo onChange={(val)=>{setRole(val)}} value={role} includeAdmins={true} includeAssistants={true} includeAgents={true} includeClients={true}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={nationalId} onChange={(e)=>{onInputChange(e, "nationalId")}} id="nationalId" keyfilter="int" maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="firstname">کد ملی</label>
                            </FloatLabel>                                                    
                        </Col>
                        <Col md={6} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <FaDate value={date} onChange={(val)=>setNewDate(val)} />
                                <label htmlFor="firstname">تاریخ تولد</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{marginTop:"25px"}}>
                            <FloatLabel>
                                <InputText value={email} onChange={(e)=>{onInputChange(e, "email")}} id="email" keyfilter="" maxLength={250} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                <label htmlFor="firstname">ایمیل</label>
                            </FloatLabel>                                                    
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{marginTop:"2px"}}>
                            <CityCombo horizontal={true} value={city} onChange={(value)=>{setCity(value);console.log("city is>", value)}} />
                        </Col>
                    </Row>

                </Dialog>
                :
                <></>
            }
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
            <ShowConfirm visible={confirmResetPasswordVisible} message="آیا از ریست کردن کلمه عبور مطمئن هستید؟" caption="اطمینان از ریست کلمه عبور" onAccept={onResetPasswordConfirm_Accept} onReject={onResetPasswordConfirm_Reject} loading={deleting} />
        </>
    )
}